import React from 'react';

interface ScenarioResultBadgeProps {
  ok: boolean;
  labelCorrect: string;
  labelWrong: string;
}

/** GCS/동공 등 공통 정답·오답 캡슐 */
export function ScenarioResultBadge({ ok, labelCorrect, labelWrong }: ScenarioResultBadgeProps): React.ReactElement {
  return ok ? (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-green-100 text-green-700">
      {labelCorrect}
    </span>
  ) : (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-red-100 text-red-700">
      {labelWrong}
    </span>
  );
}
